import { render } from "./icon-reviewed-not-by-you-counter-1.svg?vue&type=template&id=ea6bc393&scoped=true&component"
const script = {  }

import "./icon-reviewed-not-by-you-counter-1.svg?vue&type=style&index=0&id=ea6bc393&scoped=true&lang=css&component"

import exportComponent from "../../../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ea6bc393"]])

export default __exports__